// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getMessaging, isSupported } from "firebase/messaging";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries
 
// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCqRZfXR7lu2sJs76-UxPxVVm2szNJD3w8",
  authDomain: "pro-app-34b03.firebaseapp.com",
  projectId: "pro-app-34b03",
  storageBucket: "pro-app-34b03.firebasestorage.app",
  messagingSenderId: "450258795885",
  appId: "1:450258795885:web:6f0e4fed30914f198d2e64",
  measurementId: "G-0SSCQD439E"
};
 
// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
// export const messaging = getMessaging(app);
// Initialize messaging only if supported
let messaging = null;

isSupported().then((supported) => {
  if (supported) {
    messaging = getMessaging(app);
  }
});

export { messaging };
// Add Firebase to your JavaScript project | Firebase for web platforms
 